export const signInCopyEn = {
  user: {
    eyebrow: 'Plan your cruise',
    title: 'Welcome back',
    subtitle:
      'Sign in to manage your cruises, day-by-day port plans, and shore options. Everything you need to organize sailings in one place.',
    sessionExpiredSubtitle: 'Your session has expired. Sign in to return to the page you were viewing.',
    cta: 'Sign In',
    benefits: [
      'Create and manage your cruises',
      'Build day-by-day port and sea-day plans',
      'Keep per-port options and ideas organized',
    ] as const,
    alternateLink: 'Travel professional? Sign in here',
  },
  pro: {
    eyebrow: 'For Cruise Travel Professionals',
    title: 'Welcome back',
    subtitle:
      'Sign in to access your client cruises, itineraries, and list builder. Everything you need to plan and manage sailings in one place.',
    sessionExpiredSubtitle: 'Your session has expired. Sign in to return to the page you were viewing.',
    cta: 'Sign In',
    benefits: [
      'Manage clients and cruise itineraries',
      'Build day-by-day port and sea-day plans',
      'Share PDFs and keep shore-excursion options organized',
    ] as const,
    alternateLink: 'Looking for personal cruise planning?',
  },
} as const;
